import Brand from "../brand";
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import policeRegistration from "../../icons/police-registration.png";
import {getItem} from "../../utils/communication";

export default function Footer() {
    return (
        <footer className="footer">
            <Brand/>

            <div className="info flex-1">
                <div className="copyright px-2 text-0 font-bold text-sm">&copy; Hoarfroster & Collaborators.
                    All Rights Reserved.
                </div>

                <Registration/>
            </div>
        </footer>
    );
}

interface Registration {
    icp: string;
    icpLink: string;
    mps: string;
    mpsLink: string;
}

function Registration() {
    const [registration, setRegistration] = useState<Registration | null>(null);

    useEffect(() => {
        getItem("/registration").then(response => {
            if (response.code === 200) {
                setRegistration(response.data as Registration);
            }
        })
    }, []);

    if (registration === null) {
        return null;
    }

    return (
        <div className="registration text-4 font-bold text-sm">
            <span className="px-2">
                <Link to={registration.icpLink}>{registration.icp}</Link>
            </span>
            <span className="px-2 space-x-1">
                <img className="inline w-3 h-3" src={policeRegistration} alt="Police Registration"/>
                <Link to={registration.mpsLink}>{registration.mps}</Link>
            </span>
        </div>
    );
}